import { compose, withHandlers, withState, lifecycle, withProps } from 'recompose'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { rest } from 'services'
import withScrollToAnchor from 'components/common/hoc/withScrollToAnchor'
import { getAppointments } from 'selectors/getAppointments'
import { getAppointmentFormValues } from '../../selectors'
import validate from './validate'
import { getLocationPathname } from 'selectors/getPageLocation'
import {
  APPOINTMENT_FORM_NAME,
  VEHICLE_SELECTOR_TARGET_ID,
  REQUEST_APPOINTMENT_THREE_STEPS_DATE_TITLE,
  SCHEDULE_APPOINTMENT_THREE_STEPS_DATE_TITLE,
  REQUEST_CALENDAR_TITLE,
  SCHEDULE_CALENDAR_TITLE
} from 'constant'
import DateTimeAndVehicle from './DateTimeAndVehicle'
import { getCurrentStoreIsE2EAppointment } from 'selectors/getCurrentStore'
import { getRemovedPromotions, getActivePromotionsList, getAppointmentSteps } from 'components/QuickAppointmentPage/selectors'
import { setActivePromotions } from 'components/QuickAppointmentPage/actions'
import { isQuickAppointmentPage } from 'helpers/quoteRelatedPages'

const mapStateToProps = ((state) => {
  const { isTrailer } = getAppointments(state)
  const {
    appointmentDate,
    activeVehicleId,
    activePromotions
  } = getAppointmentFormValues(state)
  const { currentStep, previousStep } = getAppointmentSteps(state)
  const pathname = getLocationPathname(state)

  return {
    vehicleSelected: !!(activeVehicleId || isTrailer),
    showVehicleSelector: !!(appointmentDate && appointmentDate.time),
    isTrailer,
    isE2EAppointment: getCurrentStoreIsE2EAppointment(state),
    activePromotions,
    removedPromotions: getRemovedPromotions(state),
    activePromotionsFromState: getActivePromotionsList(state) || [],
    currentStep,
    previousStep,
    isQuickAppointmentPage: isQuickAppointmentPage(pathname)
  }
})

const shouldValidate = () => true

const withSubmitAttemptFailed = withState('submitAttemptFailed', 'setSubmitAttemptFailed', false)

const withOnSubmit = withHandlers({
  onSubmit: ({ nextPageClick, setSubmitAttemptFailed, submitAttemptFailed, showVehicleSelector }) => () =>
    (!showVehicleSelector && !submitAttemptFailed) ? setSubmitAttemptFailed(true) : nextPageClick()
})

const withAnchorProps = withProps(({ isE2EAppointment }) => ({
  targetId: VEHICLE_SELECTOR_TARGET_ID,
  padding: 60,
  title: isE2EAppointment ? SCHEDULE_APPOINTMENT_THREE_STEPS_DATE_TITLE : REQUEST_APPOINTMENT_THREE_STEPS_DATE_TITLE,
  calendarTitle: isE2EAppointment ? SCHEDULE_CALENDAR_TITLE : REQUEST_CALENDAR_TITLE
}))

const withLifecycle = lifecycle({
  componentDidUpdate({ showVehicleSelector: prevShowVehicleSelector }) {
    const {
      showVehicleSelector,
      setSubmitAttemptFailed,
      submitAttemptFailed,
      scrollToAnchorHandler,
      removedPromotions,
      activePromotionsFromState,
      currentStep,
      previousStep,
      setActivePromotions
    } = this.props

    if (currentStep !== previousStep
      && previousStep === 3
      && removedPromotions.length
      && !activePromotionsFromState.length) {
      setActivePromotions(removedPromotions)

      // TODO Update payload for multiple promotions in Phase 2
      const payload = {
        promotion: removedPromotions[0].promotionId,
        action: 'addPromo'
      }

      rest.api.addOrRemoveServicePromotion(payload)
        .catch(error => {
          console.log(error)
        })
    }

    showVehicleSelector && submitAttemptFailed && setSubmitAttemptFailed(false)
    prevShowVehicleSelector !== showVehicleSelector && showVehicleSelector && setTimeout(() => scrollToAnchorHandler())
  }
})

export default compose(
  connect(mapStateToProps, { setActivePromotions }),
  withSubmitAttemptFailed,
  withOnSubmit,
  withAnchorProps,
  withScrollToAnchor,
  withLifecycle,
  reduxForm({
    validate,
    shouldValidate,
    form: APPOINTMENT_FORM_NAME,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(DateTimeAndVehicle)
